var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return ![
    "yektanet-rubika-adv",
    "yektanet-sheypoor-adv",
    "yektanet-retail-basalam-adv"
  ].includes(_vm.getParam("account_custom_type"))
    ? _c(
        "div",
        {
          staticClass: "vertical carousel slide w-100 h-100",
          style: _vm.cssVariables,
          attrs: {
            id: "carouselDesktop",
            "data-bs-ride": "carousel",
            "data-bs-interval": "10000"
          }
        },
        [
          _vm.getParam("account_custom_type") !== "yektanet-sms-adv"
            ? _c("div", { staticClass: "carousel-inner slide-hight" }, [
                _c("div", { staticClass: "carousel-item active h-100" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between h-100"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-11 col-xl-6 d-flex flex-column align-items-center h-100"
                        },
                        [
                          _c("div", { staticClass: "w-100 flex-2" }),
                          _vm._v(" "),
                          _vm._m(0),
                          _vm._v(" "),
                          _c("div", { staticClass: "signup-arrows flex-4" }, [
                            _c("img", {
                              staticClass: "h-100 mr-auto d-block",
                              attrs: { src: _vm.signupBnrs.bnr1.arrowBottom }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-1 col-xl-6 statue-column" },
                        [
                          _c("img", {
                            staticClass: "yn-logo",
                            attrs: { src: _vm.signupBnrs.logo }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass:
                              "d-none d-xl-block mt-auto statue-image",
                            attrs: { src: _vm.signupBnrs.bnr1.statue }
                          })
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "carousel-item h-100" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between h-100"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-11 col-xl-6 d-flex flex-column align-items-center h-100"
                        },
                        [
                          _c("div", { staticClass: "signup-arrows" }, [
                            _c("img", {
                              staticClass: "h-100 mr-auto d-block",
                              attrs: { src: _vm.signupBnrs.bnr2.arrowTop }
                            })
                          ]),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          _c("div", { staticClass: "signup-arrows" }, [
                            _c("img", {
                              staticClass: "h-100 mr-auto d-block",
                              attrs: { src: _vm.signupBnrs.bnr2.arrowBottom }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-1 col-xl-6 statue-column" },
                        [
                          _c("img", {
                            staticClass: "yn-logo",
                            attrs: { src: _vm.signupBnrs.logo }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass:
                              "d-none d-xl-block mt-auto statue-image",
                            attrs: { src: _vm.signupBnrs.bnr2.statue }
                          })
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "carousel-item h-100" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between h-100"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-11 col-xl-6 d-flex flex-column align-items-center h-100"
                        },
                        [
                          _c("div", { staticClass: "signup-arrows" }, [
                            _c("img", {
                              staticClass: "h-100 mr-auto d-block",
                              attrs: { src: _vm.signupBnrs.bnr3.arrowTop }
                            })
                          ]),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _c("div", { staticClass: "signup-arrows" }, [
                            _c("img", {
                              staticClass: "h-100 mr-auto d-block",
                              attrs: { src: _vm.signupBnrs.bnr3.arrowBottom }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-1 col-xl-6 statue-column" },
                        [
                          _c("img", {
                            staticClass: "yn-logo",
                            attrs: { src: _vm.signupBnrs.logo }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass:
                              "d-none d-xl-block mt-auto statue-image",
                            attrs: { src: _vm.signupBnrs.bnr3.statue }
                          })
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "carousel-item h-100" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between h-100"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-11 col-xl-6 d-flex flex-column align-items-center h-100"
                        },
                        [
                          _c("div", { staticClass: "signup-arrows flex-4" }, [
                            _c("img", {
                              staticClass: "h-100 mr-auto d-block",
                              attrs: { src: _vm.signupBnrs.bnr4.arrowTop }
                            })
                          ]),
                          _vm._v(" "),
                          _vm._m(3),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-100 flex-2" })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-1 col-xl-6 statue-column" },
                        [
                          _c("img", {
                            staticClass: "yn-logo",
                            attrs: { src: _vm.signupBnrs.logo }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass:
                              "d-none d-xl-block mt-auto statue-image",
                            attrs: { src: _vm.signupBnrs.bnr4.statue }
                          })
                        ]
                      )
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getParam("account_custom_type") !== "yektanet-sms-adv"
            ? _c(
                "div",
                {
                  staticClass:
                    "position-absolute d-flex justify-content-center align-items-center",
                  staticStyle: {
                    left: "25px",
                    top: "50%",
                    transform: "translate(-50%) rotate(90deg)"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "#carouselDesktop",
                        role: "button",
                        "data-bs-slide": "prev"
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "28",
                            height: "28",
                            viewBox: "0 0 28 28",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M15.9425 19L17 17.9425L13.565 14.5L17 11.0575L15.9425 10L11.4425 14.5L15.9425 19Z",
                              fill: "#505050"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "#carouselDesktop",
                        role: "button",
                        "data-bs-slide": "next"
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "28",
                            height: "28",
                            viewBox: "0 0 28 28",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M12.0575 9L11 10.0575L14.435 13.5L11 16.9425L12.0575 18L16.5575 13.5L12.0575 9Z",
                              fill: "#505050"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.getParam("account_custom_type") === "yektanet-sms-adv"
            ? _c("div", { staticClass: "slide-hight " }, [
                _c("div", { staticClass: "active h-100" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between h-100" },
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-1 col-xl-6 statue-column" },
                        [
                          _c("img", {
                            staticClass: "yn-logo",
                            attrs: { src: _vm.signupBnrs.logo }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass:
                              "d-none d-xl-block mt-auto mb-5 sms-img",
                            attrs: { src: _vm.signupBnrs.sms.statue }
                          })
                        ]
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-detail-container my-3" }, [
      _c("h2", { staticClass: "info-title" }, [
        _vm._v("چرا در یکتانت ثبت‌نام کنیم؟")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-button" }, [
        _vm._v("کیفیت و تنوع نمایش‌دهنده‌ها")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "info-detail" }, [
        _vm._v(
          "\n              یکتانت به کسب‌وکار شما کمک می‌کند تا در بیش از ۲ هزار رسانه\n              پربازدید و در بهترین جایگاه‌ها تبلیغ کنید.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-detail-container my-3" }, [
      _c("h2", { staticClass: "info-title" }, [
        _vm._v("چرا در یکتانت ثبت‌نام کنیم؟")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-button" }, [
        _vm._v("گزارش کامل و دقیق تبلیغات")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "info-detail" }, [
        _vm._v(
          "\n              گزارشی دقیق و با جزئیات کامل برای هر کمپین دریافت کنید؛ تعداد\n              کلیک‌، هزینه‌ها، تعداد نمایش، اقدام‌های بعدی کاربران و … کمک\n              می‌کند تا تبلیغات را بهینه‌سازی و مدیریت کنید.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-detail-container my-3" }, [
      _c("h2", { staticClass: "info-title" }, [
        _vm._v("چرا در یکتانت ثبت‌نام کنیم؟")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-button" }, [
        _vm._v("پشتیبانی رایگان در تمام مراحل")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "info-detail" }, [
        _vm._v(
          "\n              کارشناسان یکتانت از ثبت‌نام تا ساخت و اجرای تبلیغات در کنار شما\n              هستند. با خیال راحت تبلیغ کنید!\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-detail-container my-3" }, [
      _c("h2", { staticClass: "info-title" }, [
        _vm._v("چرا در یکتانت ثبت‌نام کنیم؟")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-button" }, [
        _vm._v("اجرای تبلیغات آسان و سریع")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "info-detail" }, [
        _vm._v(
          "\n              قدم به قدم و در عرض چند دقیقه تبلیغ بسازید تا به سرعت میلیون‌ها\n              نفر محصول یا خدمات شما را ببینند.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ol",
      {
        staticClass:
          "carousel-indicators signup-carousel position-relative my-0 mx-2"
      },
      [
        _c("li", {
          staticClass: "active",
          attrs: {
            "data-bs-target": "#carouselDesktop",
            "data-bs-slide-to": "0"
          }
        }),
        _vm._v(" "),
        _c("li", {
          attrs: {
            "data-bs-target": "#carouselDesktop",
            "data-bs-slide-to": "1"
          }
        }),
        _vm._v(" "),
        _c("li", {
          attrs: {
            "data-bs-target": "#carouselDesktop",
            "data-bs-slide-to": "2"
          }
        }),
        _vm._v(" "),
        _c("li", {
          attrs: {
            "data-bs-target": "#carouselDesktop",
            "data-bs-slide-to": "3"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-11 col-xl-6 d-flex flex-column align-items-center h-100 ml-3"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "info-detail-container my-6 justify-content-center sms-detail-container"
          },
          [
            _c("h2", { staticClass: "info-title" }, [
              _vm._v("چرا پنل پیامک یکتانت؟")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-button" }, [
              _vm._v(
                "\n              جامع‌ترین بانک مشاغل | به‌روزرسانی فروردین ۱۴۰۳\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "trapezoid-sms-panel fanum" }, [
              _vm._v("\n              !فقط 107 تومان\n            ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sms-info-button" }, [
              _vm._v("\n              بدون نیاز به خرید پنل\n            ")
            ])
          ]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }